import React, { useState } from 'react';
import { styled } from '@mui/material';
import logoIconUrl from 'assets/images/logo.svg';
import { ConfirmLeavingDialog } from './ConfirmLeavingDialog';
import { useLocation, useNavigate } from 'react-router-dom';
import { RouterUrl } from 'routes';
import { clearStorageSession } from 'utils';

const StyledLogoIcon = styled('img')(({ theme }) => ({
  cursor: 'pointer',
  [`@media screen and (max-width: ${theme.breakpoints.values.md}px)`]: {
    maxWidth: '84px',
    maxHeight: '30px',
  },
}));

export const Logo = () => {
  const [open, setOpen] = useState(false);

  const { state, pathname } = useLocation();
  const navigate = useNavigate();
  const isInAccount = pathname.includes('account');

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    setOpen(false);
    clearStorageSession();
    window.location.href = window.location.origin;
  };
  const handleLogout = () => {
    clearStorageSession();
    navigate(RouterUrl.Login, { replace: true });
  };
  return (
    <>
      <StyledLogoIcon
        src={logoIconUrl}
        alt="Prestamo365"
        onClick={() => {
          state?.partialView ? handleLogout() : isInAccount ? navigate(RouterUrl.Account) : setOpen(true);
        }}
      />
      <ConfirmLeavingDialog open={open} onClose={handleClose} onSubmit={handleSubmit} />
    </>
  );
};
